// Helper to detect report type from query or resultSet
export const detectReportTypeFromQuery = (query) => {
  if (!query) return null;

  const queryStr = typeof query === 'string' ? query : JSON.stringify(query);

  // Check for productivity report
  if (queryStr.includes('cataloging_productivity_view')) {
    return 'productivity';
  }

  // Check for cataloging report
  if (queryStr.includes('cataloging_view')) {
    return 'cataloging';
  }

  // Check for circulation report
  if (queryStr.includes('circulation_view') || queryStr.includes('loan_view')) {
    return 'circulation';
  }

  return null;
};

export const detectReportTypeFromResultSet = (resultSet) => {
  if (!resultSet || !resultSet.loadResponses || resultSet.loadResponses.length === 0) {
    return null;
  }

  const data = resultSet.loadResponses[0]?.data;
  if (!data || data.length === 0) return null;

  const firstRow = data[0];
  const columns = Object.keys(firstRow);

  // Check for productivity columns
  if (columns.some(col => col.includes('cataloging_productivity_view'))) {
    return 'productivity';
  }

  // Check for cataloging columns
  if (columns.some(col => col.includes('cataloging_view'))) {
    return 'cataloging';
  }

  // Check for circulation columns
  if (columns.some(col => col.includes('circulation_view') || col.includes('loan_view'))) {
    return 'circulation';
  }

  return null;
};

export const getFieldLabelsForReportType = (reportType, catalogingLabels, productivityLabels) => {
  if (reportType === 'productivity') {
    return productivityLabels;
  }
  return catalogingLabels;
};
